import {Day, Week} from "../data/CalendarTypes";
import CalenderCard from "./CalenderCard";


export default function CalenderWeek({week, wordsPerDay}: {week: Week, wordsPerDay: number}) {
    return (
        <div className="calendar-week">
            {week.map((day: Day) => {
                return <CalenderCard key={day.date.day()} day={day} wordsPerDay={wordsPerDay} />
            })}
        </div>
    )
}
